/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_Detail_No_AllocationsInputs */

const vi_receipt_detail_no_allocations = /** @type {(inputs: Receipt_Detail_No_AllocationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không phân bổ vào đơn nào (thành số dư trả trước)`)
};

/**

* @param {Receipt_Detail_No_AllocationsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const receipt_detail_no_allocations = /** @type {((inputs?: Receipt_Detail_No_AllocationsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Detail_No_AllocationsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_receipt_detail_no_allocations(inputs)
});